import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Box, RadioGroup } from '@workwhile/ui'
import { FiltersSchema } from '../../filtersSchema'
import { prescreenStatuses } from './constants'
import { PrescreenStatusFilter as PrescreenStatusFilterType } from 'api/positions/getAllPositions'

export const PrescreenStatusFilter = () => {
  const { watch, setValue } = useFormContext<FiltersSchema>()
  const value = watch('position.prescreenStatus')

  return (
    <Box>
      <RadioGroup
        name="position.prescreenStatus"
        value={value}
        options={prescreenStatuses}
        onChange={(next) =>
          setValue(
            'position.prescreenStatus',
            next as PrescreenStatusFilterType
          )
        }
      />
    </Box>
  )
}
